import React from 'react'
import PropTypes from 'prop-types'

import SurveyItems from '../../SurveyItems'
import { CreateNewSurveyModal } from 'organisms/Admin/Surveys/CreateNewSurveyModal'
import { AdminContainer } from '../../../pages/Admin'
import ContainerShell from 'shared/components/ContainerShell'
import ContainerShellIntro from 'shared/components/ContainerShellIntro'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import useWorkspace from 'hooks/useWorkspace'
import { AllowPermission } from 'shared/components/AllowPermission'
import constants from 'config/constants'

const Surveys = ({ activeSurveys, isCreate, canCreateSurvey, loading, totalSurvey }) => {
  const workspaceToken = useWorkspace()
  return (
    <React.Fragment>
      <PageHeaderContainer
        title="Surveys"
        rightSlot={
          <AllowPermission permission={constants.permissions.manageSurveys}>
            <CreateNewSurveyModal
              canCreateSurvey={canCreateSurvey}
              isCreate={isCreate}
              workspaceToken={workspaceToken}
            />
          </AllowPermission>
        }
      />
      <AdminContainer>
        <ContainerShell
          isLoading={loading}
          intro={
            <ContainerShellIntro
              helpLinkLabel="How Simplesat surveys work"
              helpLinkUrl="https://help.simplesat.io/surveys/how-simplesat-surveys-work"
            />
          }
        >
          <SurveyItems activeSurveys={activeSurveys} loading={loading} totalSurvey={totalSurvey} />
        </ContainerShell>
      </AdminContainer>
    </React.Fragment>
  )
}

Surveys.defaultProps = {
  loading: false,
}

Surveys.propTypes = {
  canCreateSurvey: PropTypes.bool,
  isCreate: PropTypes.bool,
  loading: PropTypes.bool,
  activeSurveys: PropTypes.array,
  totalSurvey: PropTypes.number,
}

export default Surveys



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/index.js